import { BellOff, BellRing } from "lucide-react";
import { alertTypes } from "../../hooks/usePriorityActivityAlerts";

export default function ActivityAlertMuteSettings({ mutedAlerts, onToggleAlertMute }) {
  return (
    <fieldset className="activity-alert-mute-settings" data-testid="activity-alert-mute-settings">
      <legend>Browser alert types</legend>
      <div>
        {alertTypes.map((alertType) => {
          const isMuted = Boolean(mutedAlerts[alertType.id]);
          return (
            <label key={alertType.id} data-testid={`alert-mute-control-${alertType.id}`}>
              <input
                type="checkbox"
                checked={!isMuted}
                onChange={() => onToggleAlertMute(alertType.id)}
                data-testid={`alert-enabled-${alertType.id}-checkbox`}
              />
              {isMuted ? <BellOff size={14} /> : <BellRing size={14} />}
              <span>{alertType.label}</span>
              <small data-testid={`alert-mute-status-${alertType.id}`}>{isMuted ? "Muted" : "On"}</small>
            </label>
          );
        })}
      </div>
    </fieldset>
  );
}